import React, {forwardRef} from 'react';
import {connect} from 'react-redux';

import {makeMapStateToProps} from '../../../helpers/reselectHelpers';
import {getPasteAsText} from '../../../store/data/preferences/preferencesSelectors';
import {HtmlEditorBox, HtmlEditorBoxHandle, HtmlEditorBoxProps} from './htmlEditorBox';

/*
 * Props.
 */

type HtmlEditorBoxContainerProps = Omit<HtmlEditorBoxProps, 'shouldPasteAsText' | 'handleRef'>;

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  shouldPasteAsText: getPasteAsText,
}));

const ConnectedHtmlEditorBox = connect(mapStateToProps)(HtmlEditorBox);

export const HtmlEditorBoxContainer = forwardRef<HtmlEditorBoxHandle, HtmlEditorBoxContainerProps>(
  (props, ref) => <ConnectedHtmlEditorBox {...props} handleRef={ref} />,
);
